import React from "react";

const QuizTitle = ({ children, className = "" }) => {
  return <h2 className={`quiz-title ${className}`}>{children}</h2>;
};

export default QuizTitle;
